<template>
  <footer class="c-footer">
    <div class="container">
      <div v-if="general.data.information" class="row gy-4 justify-content-center">
        <div class="col-12 col-md-6 col-lg-4">
          <figure class="c-footer__logo mb-2">
            <img src="@/assets/images/logo-white.png" alt="" class="h-100 of--contain">
          </figure>
          <p class="sec-light fs-16 w-medium line-height">
              {{general.data.information.footer_description}}
          </p>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <h2 class="white fs-21 w-bold mb-4">
            Contacto
          </h2>
          <p class="sec-light fs-16 w-medium mb-2">
            <span class="fs-21 pri-alt me-1">
              <Icon icon="bytesize:telephone"/>
            </span>
              {{general.data.information.telephone}}
          </p>
          <p class="sec-light fs-16 w-medium mb-2">
            <span class="fs-21 pri-alt me-1">
              <Icon icon="ph:phone-bold"/>
            </span>
              {{general.data.information.phone}}

          </p>
          <p class="sec-light fs-16 w-medium mb-2">
            <span class="fs-21 pri-alt me-1">
              <Icon icon="octicon:mail-16"/>
            </span>
            {{general.data.information.email}}

          </p>
          <p class="sec-light fs-16 w-medium mb-4">
            <span class="fs-21 pri-alt me-1">
              <Icon icon="akar-icons:location"/>
            </span>
            {{general.data.information.address}}
          </p>
          <div class="c-social c-social--pri-light">
            <a
              target="_blank"
              v-if="general.data.information.facebook"
              :href="general.data.information.facebook"
              class="c-social__link"
            >
              <span>
                <Icon icon="ri:facebook-fill"/>
              </span>
            </a>
            <a
              target="_blank"
              v-if="general.data.information.youtube"
              :href="general.data.information.youtube"
              class="c-social__link"
            >
              <Icon icon="iconoir:youtube"/>
            </a>
            <a
              target="_blank"
              v-if="general.data.information.instagram"
              :href="general.data.information.instagram"
              class="c-social__link"
            >
              <Icon icon="fe:instagram"/>
            </a>
            <a
              target="_blank"
              v-if="general.data.information.linkedin"
              :href="general.data.information.linkedin"
              class="c-social__link"
            >
              <Icon icon="ri:linkedin-fill"/>
            </a>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <h2 class="white fs-21 w-bold mb-4 text-lg-start">
            Secciones
          </h2>
          <div class="d-flex flex-column align-items-lg-start">
            <a href="/" class="c-footer__link mb-3">
              Inicio
            </a>
            <a href="/nosotros" class="c-footer__link mb-3">
              Nosotros
            </a>
            <a href="/servicios" class="c-footer__link mb-3">
              Servicios
            </a>
            <a href="/contacto" class="c-footer__link mb-3">
              Contacto
            </a>
            <a href="/responsabilidad-social" class="c-footer__link mb-3">
              Responsabilidad Social
            </a>
            <a href="/politicas" class="c-footer__link">
              Políticas de privacidad
            </a>
          </div>
        </div>
      </div>
      <div class="c-wr c-wr--pri my-4"></div>
      <p class="text-center sec-xlight fs-16 w-bold line-height mb-0">
        © {{ year }} SERMEP
      </p>
    </div>
    <a
      v-if="general.data.information"
      :href="`https://api.whatsapp.com/send?phone=${general.data.information.phone}&text=Hola%20Quisiera%20saber%20más%20...`"
      class="c-wsp" target="_blank">
      <img src="@/assets/images/wsp.png" alt="" class="off-contain">
    </a>
  </footer>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  computed: {
    ...mapState(['general']),
  },
};
</script>
